import React from 'react';
import './header.css';
import { Dropdown } from 'primereact/dropdown';
import { Dropdown as BoostrapDropdown } from 'react-bootstrap';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import Logout from '../logout/logout';
import MasterSearch from '../masterSearch/masterSearch';
import { withRouter } from 'react-router-dom';
import Project from '../project/Project';
import Release from '../release/Release';
import EditProject from '../editProject/EditProject';
import EditRelease from '../editRelease/EditRelease';
import EditFeature from '../feature/EditFeature';
import EditStory from '../userStory/EditUserStory';
import $ from 'jquery'
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import apis from '../../services/apis';
import { customFetch } from '../../helper/api-helper/apiHerlpers';
import apiUrls from '../../constants/apiUrls';
import { format } from 'react-string-format';
import { useKeycloakState } from '../../Context/KeycloakContext';
import AppContext from "../../Context/AppContext";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const PERMISSION_LABELS = {
  AP: "Add Project",
  AF: "Add Feature",
  AR: "Add Release",
  AT: "Add Task",
  AU: "Add User Story",
  CT: "Add Comment on Task",
  CU: "Add Comment on User Story",
  DP: "Delete Project",
  DF: "Delete Feature",
  DR: "Delete Release",
  DT: "Delete Task",
  DU: "Delete User Story",
  EP: "Edit Project",
  EF: "Edit Feature",
  ER: "Edit Release",
  ET: "Edit Task",
  EU: "Edit User Story",
  GR: "Generate Report",
  LF: "List Feature",
  LS: "List User Story",
  LU: "List Users",
  MP: "Manage Project Members",
  
  MR: "Manage Role"

};



class Header extends React.Component {
    static contextType = AppContext;
    _isMounted = false;
    constructor(props) {
        super(props);
        //Show task if URL have taskId
        var taskId = this.getURLParamByName('t');
        var projectId = null;
        var releaseId = null;
        if (!taskId) {
            projectId = this.getURLParamByName('p');
            releaseId = this.getURLParamByName('r');
        }
       
        const storedToken = localStorage.getItem('keycloakToken');
       
        this.state = {
            loadTaskHit: 0,
            userId: this.props.userId,
            taskId,
            masterProjectId: projectId,
            masterProjects: [],
            masterReleaseId: releaseId,
            masterReleaseList: [],
            masterFeatureId: null,
            masterFeatureList: [],
            masterUserId: null,
            masterUsers: [],
            loggedInUserName: "Sonu B",
            showStoryList: false,
            showAddUserStory: false,
            showFeatureList: false,
            showPermissionModal: false,

            allowAutoLoad: false, 
            addProject: false,
            addRelease: false,
            openProjectList: false,
            openReleaseList: false,
            openFeatureList: false,
            showAddTask: false,

            showFilterPopup: false,
            filterStartDate: null,
            filterEndDate: null,

            activeFilterType: '',
            recentTaskModifiedDays: '0',
            taskModifiedBeforeDays: '0',
            filterDateRange: '', 
        }
        this.masterProjectChange = this.masterProjectChange.bind(this);
        this.masterReleaseChange = this.masterReleaseChange.bind(this);
        this.masterFeatureChange = this.masterFeatureChange.bind(this);
        this.masterUserChange = this.masterUserChange.bind(this);
        this.toggleFilter = this.toggleFilter.bind(this);
        this.showAddTask = props.addTask;
        this.showAddUserStory = props.addUserStory;
        this.showAddFeature = props.showAddFeature; 
        this.showStoryList = props.userStoryList;
       
        this.addProjectHandler = this.addProjectHandler.bind(this);
        this.hideProjectHandler = this.hideProjectHandler.bind(this);
        this.addReleaseHandler = this.addReleaseHandler.bind(this);
        this.hideReleaseHandler = this.hideReleaseHandler.bind(this);
        this.openProjectListHandler = this.openProjectListHandler.bind(this);
        this.hideEditProjectHandler = this.hideEditProjectHandler.bind(this);
        this.openReleaseListHandler = this.openReleaseListHandler.bind(this);
        this.openFeatureHandler = this.openFeatureHandler.bind(this);
        this.openStoryListHandler = this.openStoryListHandler.bind(this);
        this.hideReleaseListHandler = this.hideReleaseListHandler.bind(this);
        this.hideFeatureHandler = this.hideFeatureHandler.bind(this);
        this.hideStoryHandler = this.hideStoryHandler.bind(this);
        this.openFeatureListHandler = this.openFeatureListHandler.bind(this);
        this.hideFeatureListHandler = this.hideFeatureListHandler.bind(this);
        this.filterDateRangePickerChange = this.filterDateRangePickerChange.bind(this);
        this.setFilter = this.setFilter.bind(this);
        this.clearFilter = this.clearFilter.bind(this);
        this.loadMasterReleaseDdl = this.loadMasterReleaseDdl.bind(this);
        this.loadMasterProjectDdl = this.loadMasterProjectDdl.bind(this);
        this.onFilterPopupDropdownToggle = this.onFilterPopupDropdownToggle.bind(this);
        this.loadMasterFeatureDdl = this.loadMasterFeatureDdl.bind(this);
        
       
    }

    onFilterPopupDropdownToggle(showFilterPopup) {
        if (showFilterPopup) {
            if (this._isMounted) {
    this.setState({ showFilterPopup });
}
        }
        else if (!$('.daterangepicker').is(':visible')) {
            this.setState({
                showFilterPopup
            });
        }
    }

    getURLParamByName(parameterName) {
        var result = null,
            tmp = [];
        window.location.search
            .substr(1)
            .split("&")
            .forEach(function (item) {
                tmp = item.split("=");
                if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });
        return result !== null && !isNaN(parseInt(result)) ? parseInt(result) : result;
    }
    
openPermissionModal = () => {
  this.setState({ showPermissionModal: true });
};

closePermissionModal = () => {
  this.setState({ showPermissionModal: false });
};


    hideReleaseListHandler() {
        this.setState({ openReleaseList: false })
    }
    hideFeatureHandler() {
        this.setState({ openFeatureList: false })
    }
    hideStoryHandler() {
        this.setState({ openStoryList: false })
    }
    openReleaseListHandler() {
        this.props.hideAllAddForms();
        this.setState({ openReleaseList: true })
    }
    openFeatureHandler() {
        this.props.hideAllAddForms();
        this.setState({ openFeatureList: true })
    }
    openStoryListHandler() {
        this.props.hideAllAddForms();
        this.setState({ openStoryList: true })
    }
     hideFeatureListHandler() {
        this.setState({ openFeatureList: false })
    }
    openFeatureListHandler() {
        this.props.hideAllAddForms();
        this.setState({ openFeatureList: true })
    }
    hideEditProjectHandler() {
        this.setState({ openProjectList: false })
    }
    openProjectListHandler() {
        this.props.hideAllAddForms();
        this.setState({ openProjectList: true })
    }

    hideReleaseHandler() {
        this.setState({ addRelease: false })
    }
    addReleaseHandler() {
        this.props.hideAllAddForms();
        this.setState({ addRelease: true })
    }

    hideProjectHandler(show) {
        this.setState({ addProject: show })
    }

    addProjectHandler() {
        this.props.hideAllAddForms();
        this.setState({ addProject: true })
    }

   goToManageProjectRoles = () => {
  const { masterProjectId, masterProjects } = this.state;

  if (!masterProjectId) return;

 const selectedProject = masterProjects.find(
  p => String(p.value) === String(masterProjectId)
);

const projectName = selectedProject?.label || "";

console.log("Selected project",projectName);
  
  localStorage.setItem(
  "selectedProject",
  JSON.stringify({
    projectId: masterProjectId,
    projectName
  })
);


  this.props.history.push(`/manage-role?p=${masterProjectId}`, { projectName: projectName });

};




hasProjectAccess = (projects, projectId) => {
  return projects.some(p => String(p.value) === String(projectId));
};



    setFilter(e) {
        var activeFilter = this.state.activeFilterType;
        $('#filterPopup .form-error').html('');
        if (activeFilter.length === 0) {
            $('#filterPopup .form-error').html('No filter is selected');
            return;
        }
        var filterDays = 1;
        if (activeFilter === 'date-range') {
            if (this.state.filterDateRange === '') {
                $('#filterPopup .form-error').html('Date range is not selected');
                return;
            }
            else {
                var startDate = this.state.filterDateRange.split('-')[0].trim();
                var endDate = this.state.filterDateRange.split('-')[1].trim();
                this.setState({
                    filterStartDate: new Date(startDate + " 00:00:00"),
                    filterEndDate: new Date(endDate + " 23:59:59"),
                });
            }
        }
        else if (activeFilter === 'last-n-days') {
            if (this.state.recentTaskModifiedDays === '0') {
                $('#filterPopup .form-error').html('No of days are not selected');
                return;
            }
            var start = new Date();
            filterDays = parseInt(this.state.recentTaskModifiedDays);
            start.setDate(start.getDate() - filterDays);

            this.setState({
                filterStartDate: new Date(moment(start).format('YYYY-MM-DD') + " 00:00:00"),
                filterEndDate: new Date(moment(new Date()).format('YYYY-MM-DD') + " 23:59:59"),
                filterDateRange: ''
            });
        }
        else if (activeFilter === 'before-n-days') {
            if (this.state.taskModifiedBeforeDays === '0') {
                $('#filterPopup .form-error').html('No of days are not selected');
                return;
            }
            var filterEndDate = new Date();
            filterDays = parseInt(this.state.taskModifiedBeforeDays);
            filterEndDate.setDate(filterEndDate.getDate() - filterDays)
            this.setState({
                filterStartDate: null,
                filterEndDate: new Date(moment(filterEndDate).format('YYYY-MM-DD') + " 23:59:59"),
                filterDateRange: ''
            });
        }

        localStorage.setItem("timeFilter", JSON.stringify({ activeFilterType: activeFilter, filterDays, filterDateRange: this.state.filterDateRange }));

        if (e) $('body').click();
         

    }

    clearFilter() {
        $('#filterPopup .form-group').removeClass("active-drop-color");
        if (this._isMounted) {
        this.setState({
            filterStartDate: null,
            filterEndDate: null,
            activeFilterType: '',
            recentTaskModifiedDays: '0',
            taskModifiedBeforeDays: '0',
            filterDateRange: ''
        }, function () {
            localStorage.removeItem("timeFilter");
            
            $('body').click();
        });
    }
    }

    setActiveFilterType(activeFilterType) {
        if (this.state.activeFilterType === activeFilterType) return;
        var recentTaskModifiedDays = '0', taskModifiedBeforeDays = '0', filterDateRange = '';
        if (activeFilterType === "before-n-days") {
            recentTaskModifiedDays = '0';
            filterDateRange = '';
        }
        else if (activeFilterType === 'last-n-days') {
            taskModifiedBeforeDays = '0';
            filterDateRange = '';
        }
        this.setState({
            activeFilterType,
            recentTaskModifiedDays,
            taskModifiedBeforeDays,
            filterDateRange
        });
    }

    filterDateRangePickerChange(start, end) {
        if (this._isMounted) {
        this.setState({
            filterStartDate: start.toDate(),
            filterEndDate: end.toDate(),
            filterDateRange: start.format('MM/DD/YYYY - ') + end.format('MM/DD/YYYY')
        });
    }
    }

    toggleFilter() {
        if (this._isMounted) {
    this.setState({
        showFilterPopup: !this.state.showFilterPopup
    });
}

    }

    async loadMasterProjectDdl() {
        const storedToken = localStorage.getItem('keycloakToken');
         const { applicationId, siteId } = this.context;
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        const isGlobalAdmin = JSON.parse(localStorage.getItem("isGlobalAdmin"));
        const projects = await apis.getProjects(
            applicationId,
            siteId,
            this.state.userId,
            isGlobalAdmin,
            storedToken
            );

            if (this._isMounted) {
            this.setState({ masterProjects: projects });
            }
        }

    async loadMasterReleaseDdl() {
        const storedToken = localStorage.getItem('keycloakToken');
        const { applicationId, siteId } = this.context;
        const releases = await apis.getReleaseList(
            applicationId,
            siteId,
            this.state.masterProjectId,
            storedToken
            );

            if (this._isMounted) {
            this.setState({ masterReleaseList: releases });
            }

    }
    async loadMasterFeatureDdl(projectId) {
    const storedToken = localStorage.getItem('keycloakToken');
    const { applicationId, siteId } = this.context;
    if (!projectId) {
        this.setState({ masterFeatureList: [], masterFeatureId: null });
        return;
    }

    let featureList = [];
    try {
        featureList = await apis.getFeatureList(applicationId, siteId,projectId, storedToken);
    } catch (err) {
        console.error("Failed to load features:", err);
        featureList = [];
    }

   if (this._isMounted) {
  this.setState({
    masterFeatureList: featureList || [],
    masterFeatureId: null
  });
}
}





    componentDidUpdate(prevProps) {
  if (prevProps.isAdmin !== this.props.isAdmin) {
    this.loadMasterProjectDdl();
  }
  
}

async componentDidMount() {
  this._isMounted = true;

  const storedToken = localStorage.getItem("keycloakToken");
  const { applicationId, siteId } = this.context;
  const isGlobalAdmin = JSON.parse(localStorage.getItem("isGlobalAdmin"));

 
  const projects = await apis.getProjects(
    applicationId,
    siteId,
    this.state.userId,
    isGlobalAdmin,
    storedToken
  );

  if (this._isMounted) {
    this.setState({ masterProjects: projects });
  }

  if (this.state.masterProjectId && !this.state.taskId) { 
    const hasProjectAccess = projects.some(
      p => String(p.value) === String(this.state.masterProjectId)
    );

    if (!hasProjectAccess) {
  toast.warning("You don’t have access to this project", {
    position: toast.POSITION.TOP_RIGHT,
  });

  if (this._isMounted) {
    this.setState({
      masterProjectId: null,
      masterReleaseId: null,
      masterReleaseList: [],
      masterFeatureList: [],
      
      allowAutoLoad: false,
      loadTaskHit: this.state.loadTaskHit + 1,
    });
  }

  return;
}

if (this._isMounted) {
  this.setState({
   
    allowAutoLoad: true   
  });
}


  }

  
  if (this.state.masterProjectId && this.props.dispatch) {
    this.props.dispatch({
      type: "SET_SELECTED_PROJECT",
      payload: this.state.masterProjectId
    });
  }

  
if (this.state.taskId && this.state.taskId > 0) {
  let taskResponse;

  try {
    taskResponse = await customFetch(
      format(apiUrls.getTaskById, applicationId, siteId, this.state.taskId),
      storedToken
    );
  } catch (e) {
    taskResponse = null;
  }

  
  const taskHB = taskResponse?.taskdetailsHB;


if (
  !taskHB ||
  taskHB.taskId === 0 ||
  taskHB.projectId === 0
) {
  this.showAddTask(true, null, {
    isTaskDeleted: true,
    taskId: this.state.taskId
  });
  return;
}


  const task = taskResponse.taskdetailsHB;
  const projectId = task.projectId;
  const releaseId = task.releaseId;

  
  const hasTaskProjectAccess = projects.some(
    p => String(p.value) === String(projectId)
  );

  if (!hasTaskProjectAccess) {
    toast.warning("You don’t have access to this task", {
      position: toast.POSITION.TOP_RIGHT
    });
    return;
  }

  
  const releaseList = await apis.getReleaseList(
    applicationId,
    siteId,
    projectId,
    storedToken
  );

  const featureList = await apis.getFeatureList(
    applicationId,
    siteId,
    projectId,
    storedToken
  );

  if (this._isMounted) {
    this.setState({
      loadTaskHit: this.state.loadTaskHit + 1,
      masterProjectId: projectId,
      masterReleaseId: releaseId,
      masterReleaseList: releaseList || [],
      masterFeatureList: featureList || [],
      allowAutoLoad: true
    });
  }

  this.showAddTask(true, task, this.state);
}


 
  const users = await apis.getUsers(applicationId, siteId, storedToken);

  if (this._isMounted) {
    this.setState({ masterUsers: users });
  }

 
  if (this.state.masterProjectId) {
    const releaseList = await apis.getReleaseList(
      applicationId,
      siteId,
      this.state.masterProjectId,
      storedToken
    );

    const featureList = await apis.getFeatureList(
      applicationId,
      siteId,
      this.state.masterProjectId,
      storedToken
    );

    if (this._isMounted) {
      this.setState({
        masterReleaseList: releaseList,
        masterFeatureList: featureList
      });
    }
  }

 
  if (localStorage.getItem("timeFilter")) {
    const timeFilter = JSON.parse(localStorage.getItem("timeFilter"));
    if (timeFilter) {
      this.setState(
        {
          activeFilterType: timeFilter.activeFilterType,
          recentTaskModifiedDays:
            timeFilter.activeFilterType === "last-n-days"
              ? timeFilter.filterDays
              : "0",
          taskModifiedBeforeDays:
            timeFilter.activeFilterType === "before-n-days"
              ? timeFilter.filterDays
              : "0",
          filterDateRange: timeFilter.filterDateRange || ""
        },
        () => this.setFilter()
      );
    }
  }
}



    componentWillUnmount() {
  this._isMounted = false;
}
  async masterProjectChange(e) {
    const projectId = e.target.value;
    const storedToken = localStorage.getItem("keycloakToken");
     const { applicationId, siteId } = this.context;
if (this._isMounted) {
    this.setState({
        masterProjectId: projectId,
        masterReleaseId: null,
        masterFeatureId: null
    });
}
	
	if (this.props.dispatch) {
  this.props.dispatch({
    type: "SET_SELECTED_PROJECT",
    payload: projectId,
  });
}

    if (projectId) {
        this.props.history.push(`/dashboard?p=${projectId}`);

        
        await this.loadMasterFeatureDdl(projectId);

        
        try {
            const releases = await apis.getReleaseList(applicationId, siteId,projectId, storedToken);
            this.setState({ masterReleaseList: releases || [] });
        } catch (err) {
            console.error("Failed to load releases:", err);
            this.setState({ masterReleaseList: [] });
        }

    } else {
       if (this._isMounted) { this.setState({ masterReleaseList: [], masterFeatureList: [] });}
        this.props.history.push(`/dashboard`);
    }
}

    async masterReleaseChange(e) {
    const releaseId = e.target.value;
    const projectId = this.state.masterProjectId;
if (this._isMounted) {
    this.setState({
        masterReleaseId: releaseId,
        masterFeatureId: null
    });
}

    if (releaseId && projectId) {
        this.props.history.push(`/dashboard?p=${projectId}&r=${releaseId}`);

       
        await this.loadMasterFeatureByProjectAndRelease(projectId, releaseId);
    }
    else if (projectId) {
        this.props.history.push(`/dashboard?p=${projectId}`);

        
        await this.loadMasterFeatureDdl(projectId);
    }
}
async loadMasterFeatureByProjectAndRelease(projectId, releaseId) {
    const storedToken = localStorage.getItem('keycloakToken');
    const { applicationId, siteId } = this.context;

    if (!projectId) {
        this.setState({ masterFeatureList: [], masterFeatureId: null });
        return;
    }

    try {
        const response = await customFetch(
            format(
                apiUrls.getFeatureListByProjectAndRelease,
                applicationId, siteId,
                projectId,
                releaseId
            ),
            storedToken
        );

        const parsed = response?.json ? JSON.parse(response.json) : {};
        const featureList = parsed.featurelist || [];

       
        const mappedFeatureList = featureList.map(f => ({
            label: f.title,
            value: f.featureId,
            ...f   
        }));

        if (this._isMounted) {
            this.setState({
                masterFeatureList: mappedFeatureList,
                masterFeatureId: null
            });
            }

    } catch (err) {
        console.error("Failed to load features by release:", err);
       if (this._isMounted) {
  this.setState({ masterFeatureList: [], masterFeatureId: null });
}

    }
}


    masterFeatureChange(e) {
    this.setState({
        masterFeatureId: e.target.value
    });
}


    masterUserChange(e) {
        this.setState({
            masterUserId: e.target.value,
        });
    }

    showHeaders() {
        $('.headerDdlMenu').toggleClass('show');
    }

     ReportMethod = (event) => {
        event.preventDefault();
        this.props.history.push("/report");
    }

     AssignProjectManagerMethod = (event) => {
        event.preventDefault();
        this.props.history.push("/project-manager");
    }
    ManageRolesMethod = (event) => {
        event.preventDefault();
        this.props.history.push("/roles");
    }
    NavigateToDashbaord = (event) => {
        event.preventDefault();
        this.props.history.push("/dashboard");
    }

    hasPermission = (permissionCode) => {
  const isGlobalAdmin =
    JSON.parse(localStorage.getItem("isGlobalAdmin")) === true;

  if (isGlobalAdmin) return true;

  const projectId = String(this.state.masterProjectId); 

  if (!projectId) return false;

  const { projectPermissions } = this.props;

  return projectPermissions[projectId]?.includes(permissionCode);
};
renderProjectPermissions = () => {
  const projectId = String(this.state.masterProjectId);

  const { projectPermissions } = this.props;

  const isGlobalAdmin =
    JSON.parse(localStorage.getItem("isGlobalAdmin"));

  const permissions = projectPermissions[projectId] || [];

  if (isGlobalAdmin) {
    return (
      <ul className="list-group">
        {Object.keys(PERMISSION_LABELS).map(code => (
          <li key={code} className="list-group-item">
            {PERMISSION_LABELS[code]}
          </li>
        ))}
      </ul>
    );
  }

 
  if (!permissions.length) {
    return <p>No permissions assigned for this project.</p>;
  }

  return (
    <ul className="list-group">
      {permissions.map(code => (
        <li key={code} className="list-group-item">
          {PERMISSION_LABELS[code] || code}
        </li>
      ))}
    </ul>
  );
};
getCurrentProjectRole = () => {
  const projectId = String(this.state.masterProjectId);

  
  const userPermissions =
    JSON.parse(localStorage.getItem("userPermissions")) || [];

  
  if (userPermissions.includes("Administrator")) {
    return { roleName: "Administrator" };
  }

  if (userPermissions.includes("SMA_MS")) {
    return { roleName: "Smark Manager" };
  }

  
  if (!projectId) return null;

  const projectRoles =
    JSON.parse(localStorage.getItem("projectRoles")) || {};

  return projectRoles[projectId] || null;
};





    render() {
        const { location, history } = this.props;
        const isGlobalAdmin = JSON.parse(localStorage.getItem("isGlobalAdmin"));

        const isDashboard = location.pathname === "/dashboard";
        const isProjectManager = location.pathname === "/project-manager";
        return (<div id="header_area">
            <header id="navbar" className="w-100 float-left top-bar">
                <div className="navbar-nav ml-auto st-m">
                    <Logout />
                </div>
                <nav className="navbar navbar-expand-lg navbar-light">
                    <button onClick={this.showHeaders} className="navbar-toggler" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse headerDdlMenu" id="navbarSupportedContent">
                        <div className="navbar-nav mr-auto">
                            <div>
                                <div className="form-inline">
                                    <div className="4 st-w-100">
                                        <div className="form-group">
                                            <Dropdown className="master-dropdown master-dropdown-first" filter showClear placeholder="Select project" value={this.state.masterProjectId} onChange={this.masterProjectChange} options={this.state.masterProjects} panelClassName="master-dropdown-panel" />
                                        </div>
                                    </div>

                                    <div className="1 st-hide"> &nbsp; </div>
                                    <div className="3 st-w-100">
                                        <div className="form-group">
                                            <Dropdown className="master-dropdown" filter placeholder="Select release" value={this.state.masterReleaseId} onChange={this.masterReleaseChange} options={this.state.masterReleaseList} showClear panelClassName="master-dropdown-panel" />
                                        </div>
                                    </div>
                                   
                                   <div className="1 st-hide"> &nbsp; </div>
                                    <div className="3 st-w-100">
                                        <div className="form-group">
                                            <Dropdown className="master-dropdown" filter placeholder="Select feature" value={this.state.masterFeatureId} onChange={this.masterFeatureChange} options={this.state.masterFeatureList} showClear panelClassName="master-dropdown-panel" />
                                        </div>
                                    </div>
                                    <div className="1 st-hide"> &nbsp; </div>
                                    {this.hasPermission("LU") ?
                                        <div className="3 st-w-100">
                                            <div className="form-group">
                                                <Dropdown className="master-dropdown" filter showClear placeholder="Select user" value={this.state.masterUserId} onChange={this.masterUserChange} options={this.state.masterUsers} panelClassName="master-dropdown-panel" />
                                            </div>
                                        </div> : ""}
                                    <div className="1 st-hide"> &nbsp; </div>
                                    <BoostrapDropdown id="filterPopupDropdown" onToggle={this.onFilterPopupDropdownToggle} show={this.state.showFilterPopup}>
                                        <BoostrapDropdown.Toggle as="span" title="Date filter" className="btn btn-light st-pdng-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-calendar-minus" width="30" height="30" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#000000" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                <rect x="4" y="5" width="16" height="16" rx="2" />
                                                <line x1="16" y1="3" x2="16" y2="7" />
                                                <line x1="8" y1="3" x2="8" y2="7" />
                                                <line x1="4" y1="11" x2="20" y2="11" />
                                                <line x1="10" y1="16" x2="14" y2="16" />
                                            </svg>
                                        </BoostrapDropdown.Toggle>
                                        <BoostrapDropdown.Menu id="filterPopup" className="p-3 wd-200">
                                            <button type="button" className="btncrossFilterPopup close" aria-label="Close" style={{ display: 'none' }}>
                                                <span aria-hidden="true">&times; </span>
                                            </button>
                                            <div onClick={() => { this.setActiveFilterType('last-n-days') }} data-type="last-n-days" className={this.state.activeFilterType === "last-n-days" ? "form-group form-inline mb-2 active-drop-color" : "form-group form-inline mb-2"}>
                                                <label className="font13"><strong>Recent Task Modified</strong></label>
                                                <select className="ml-1" value={this.state.recentTaskModifiedDays} onChange={(e) => { var value = e.target.value; this.setState({ recentTaskModifiedDays: value }) }}>
                                                    <option>0</option>
                                                    <option>1</option>
                                                    <option>2</option>
                                                    <option>3</option>
                                                    <option>4</option>
                                                    <option>5</option>
                                                    <option>6</option>
                                                    <option>7</option>
                                                </select>
                                            </div>
                                            <div className="dropdown-divider"></div>
                                            <div onClick={() => { this.setActiveFilterType('before-n-days') }} data-type="before-n-days" className={this.state.activeFilterType === "before-n-days" ? "form-group form-inline mb-2 active-drop-color" : "form-group form-inline mb-2"}>
                                                <label className="font13"><strong>Task Modified Before</strong></label>
                                                <select className="ml-1" value={this.state.taskModifiedBeforeDays} onChange={(e) => { var value = e.target.value; this.setState({ taskModifiedBeforeDays: value }) }}>
                                                    <option>0</option>
                                                    <option>1</option>
                                                    <option>2</option>
                                                    <option>3</option>
                                                    <option>4</option>
                                                    <option>5</option>
                                                    <option>6</option>
                                                    <option>7</option>
                                                </select>
                                            </div>
                                            <div className="dropdown-divider"></div>
                                            <div className="row">
                                                <div className="col-sm-8 filter-input">
                                                    <div onClick={() => { this.setActiveFilterType('date-range') }} data-type="date-range" className={this.state.activeFilterType === "date-range" ? "form-group form-inline mb-2 active-drop-color" : "form-group form-inline mb-2"}>
                                                        <label className="font13"><strong>Date Range</strong></label>
                                                        <DateRangePicker initialSettings={{ autoApply: true, maxDate: new Date() }} onCallback={this.filterDateRangePickerChange}>
                                                            <input type="text" id="daterange" className="form-control" value={this.state.filterDateRange} onChange={() => { }} />
                                                        </DateRangePicker>
                                                    </div>
                                                </div>
                                                <div className="col-sm-4 filter-button">
                                                    <button type="button" onClick={this.setFilter} id="setFilter" className="btn btn-sm btn-light border-dark ml-2 btnCloseFilterPopup"><small className="btnCloseFilterPopup">Set</small></button>
                                                    <button type="button" onClick={this.clearFilter} className="btn btn-sm btn-light border-dark ml-2 btnCloseFilterPopup"><small className="btnCloseFilterPopup">Clear</small></button>
                                                </div>
                                            </div>
                                        </BoostrapDropdown.Menu>
                                    </BoostrapDropdown>
                                    
                                    <MasterSearch
                                        data={this.state}
                                        loadTaskHit={this.state.loadTaskHit}
                                        allowAutoLoad={this.state.allowAutoLoad}
                                        getTaskList={this.props.getTaskList}
                                    />
                                    

                                    <span title="Comments" onClick={this.props.showComments} type="button" className="text-white btn btn-light btn-sm ml-2 cmt-show">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-message-circle" width="26" height="26" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#000000" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1" />
                                            <line x1="12" y1="12" x2="12" y2="12.01" />
                                            <line x1="8" y1="12" x2="8" y2="12.01" />
                                            <line x1="16" y1="12" x2="16" y2="12.01" />
                                        </svg>
                                    </span>
                                                                        
                                       {(this.hasPermission("LS") || isGlobalAdmin)? (<span
                                        title="User stories"
                                        onClick={() =>
                                            this.showStoryList(true, null, this.state, 'openStoryList')
                                        }
                                        type="button"
                                        className="text-white btn btn-light btn-sm ml-2 left-button-top"
                                        style={{
                                            display:
                                                this.state.masterProjectId && !this.state.masterUserId
                                                ? "inline-block"
                                                : "none"
                                            }}
                                        >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="icon icon-tabler icon-tabler-border-outer"
                                            width="26"
                                            height="26"
                                            viewBox="0 0 24 24"
                                            strokeWidth="1.5"
                                            stroke="#000000"
                                            fill="none"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <rect x="4" y="4" width="16" height="16" rx="2" />
                                            <line x1="12" y1="8" x2="12" y2="8.01" />
                                            <line x1="8" y1="12" x2="8" y2="12.01" />
                                            <line x1="12" y1="12" x2="12" y2="12.01" />
                                            <line x1="16" y1="12" x2="16" y2="12.01" />
                                            <line x1="12" y1="16" x2="12" y2="16.01" />
                                        </svg>
                                        </span>) :" "} 
                                        {(this.hasPermission("LF")) || isGlobalAdmin?   <span
                                        title="Features"
                                        onClick={() => this.props.showFeatureList(true, this.state)}
                                        className="text-white btn btn-light btn-sm ml-2 left-button-top"
                                        style={{
                                            display:
                                                this.state.masterProjectId && !this.state.masterUserId
                                                ? "inline-block"
                                                : "none"
                                            }}
                                        >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
                                            <rect x="3" y="3" width="7" height="7" />
                                            <rect x="14" y="3" width="7" height="7" />
                                            <rect x="14" y="14" width="7" height="7" />
                                            <rect x="3" y="14" width="7" height="7" />
                                        </svg>
                                        </span> : ""}
                                     {(this.hasPermission("MP")) || isGlobalAdmin?<span
                                            title="Project Members & Roles"
                                            onClick={this.goToManageProjectRoles}
                                            className="text-white btn btn-light btn-sm ml-2 left-button-top"
                                            style={{ display: !this.state.masterProjectId && "none" }}
                                            >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="26"
                                                height="26"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="black"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                                <circle cx="9" cy="7" r="4" />
                                                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                            </svg>
                                            </span> : ""}
                                            
                                                <span
                                                    title="View Project Permissions"
                                                    onClick={this.openPermissionModal}
                                                    className="text-white btn btn-light btn-sm ml-2 left-button-top"
                                                    style={{ display: !this.state.masterProjectId && "none" }}
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="black"
                                                        strokeWidth="1.8"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        >
                                                        <path d="M12 2l7 4v6c0 5-3.5 9-7 10-3.5-1-7-5-7-10V6l7-4z" />
                                                        <path d="M9 12l2 2 4-4" />
                                                        </svg>

                                                </span>
                                                

                                            
                                    
                                   
                                </div>
                            </div>
                        </div>

                        <div className="navbar-nav ml-auto">
                            <ul className="rt-pnl">
                                {( isDashboard &&(this.hasPermission("EP") ||this.hasPermission("ER") ||this.hasPermission("EF")|| this.hasPermission("EU") || this.hasPermission("DR") || this.hasPermission("DF") || this.hasPermission("DU"))) ?
                                    <li>
                                        <BoostrapDropdown>
                                            <BoostrapDropdown.Toggle as="a" className="rt-list add-form-btn" id="dropdown-basic">
                                                <i className="fa fa-list-ul" aria-hidden="true"></i> Edit
                                            </BoostrapDropdown.Toggle>
                                            <BoostrapDropdown.Menu>
                                                 { this.hasPermission("EP")? <BoostrapDropdown.Item onClick={this.openProjectListHandler}>Project</BoostrapDropdown.Item>: ""}
                                                { this.hasPermission("ER") || this.hasPermission("DR")? <BoostrapDropdown.Item onClick={this.openReleaseListHandler}>Release</BoostrapDropdown.Item>: ""}
                                                 { this.hasPermission("EF") || this.hasPermission("DF")?<BoostrapDropdown.Item onClick={this.openFeatureHandler}>Feature</BoostrapDropdown.Item>: ""}
                                                { this.hasPermission("EU") || this.hasPermission("DU")?<BoostrapDropdown.Item onClick={this.openStoryListHandler}>Userstory</BoostrapDropdown.Item>: ""}
                                            </BoostrapDropdown.Menu>
                                        </BoostrapDropdown>
                                    </li> : ""}

                                    {isGlobalAdmin ||this.hasPermission("GR") ?
                                    <li>
                                        <BoostrapDropdown>
                                            <BoostrapDropdown.Toggle as="a" className="rt-list add-form-btn" id="dropdown-basic">
                                                <i className="" aria-hidden="true"></i> Manage
                                            </BoostrapDropdown.Toggle>
                                            <BoostrapDropdown.Menu>
                                                {(isGlobalAdmin && isDashboard) ?<BoostrapDropdown.Item onClick={this.ManageRolesMethod}>Roles</BoostrapDropdown.Item>: ""}
                                                {/*{(isGlobalAdmin && isDashboard) ?<BoostrapDropdown.Item onClick={this.AssignProjectManagerMethod}>Project Manager</BoostrapDropdown.Item>: ""}*/}
												 {((isGlobalAdmin || this.hasPermission("GR")) && isProjectManager) ?<BoostrapDropdown.Item onClick={this.NavigateToDashbaord}>ScrumBoard</BoostrapDropdown.Item>: ""}
                                                {isGlobalAdmin ||this.hasPermission("GR") ? <BoostrapDropdown.Item onClick={this.ReportMethod}>Report</BoostrapDropdown.Item>: ""}
                                            </BoostrapDropdown.Menu>
                                        </BoostrapDropdown>
                                    </li> : ""}

                                {/* {this.state.isAdmin ?
                                    <li>
                                        <BoostrapDropdown>
                                            <BoostrapDropdown.Toggle as="a" className="rt-list add-form-btn" id="dropdown-basic">
                                                <i className="fa fa-plus" aria-hidden="true"></i> Add New Project/Release
                                            </BoostrapDropdown.Toggle>
                                            <BoostrapDropdown.Menu>
                                                <BoostrapDropdown.Item onClick={this.addProjectHandler}>Project</BoostrapDropdown.Item>
                                                <BoostrapDropdown.Item onClick={this.addReleaseHandler}>Release</BoostrapDropdown.Item>
                                            </BoostrapDropdown.Menu>
                                        </BoostrapDropdown>
                                    </li> : ""} */}

                                    {isDashboard &&(this.hasPermission("AR") ||this.hasPermission("AF") ||this.hasPermission("AU")|| this.hasPermission("AT"))? (
                                    <li>
                                        <BoostrapDropdown>
                                        <BoostrapDropdown.Toggle
                                            as="a"
                                            className="rt-list add-form-btn"
                                            id="dropdown-basic"
                                        >
                                            <i className="fa fa-plus" aria-hidden="true"></i> Add New
                                        </BoostrapDropdown.Toggle>

                                        <BoostrapDropdown.Menu>
                                            {/* Project – Global Admin only */}
                                            {isGlobalAdmin && (
                                            <BoostrapDropdown.Item onClick={this.addProjectHandler}>
                                                Project
                                            </BoostrapDropdown.Item>
                                            )}

                                            {/* Release */}
                                            {this.hasPermission("AR") && (
                                            <BoostrapDropdown.Item onClick={this.addReleaseHandler}>
                                                Release
                                            </BoostrapDropdown.Item>
                                            )}

                                            {/* Feature */}
                                           {this.hasPermission("AF") && (
                                            <BoostrapDropdown.Item
                                                onClick={() => {
                                                this.props.hideAllAddForms();
                                                this.showAddFeature(true, null, this.state);
                                                }}
                                            >
                                                Feature
                                            </BoostrapDropdown.Item>
                                            )}

                                            {/* User Story */}
                                           {this.hasPermission("AU") && (
                                            <BoostrapDropdown.Item
                                                onClick={() => {
                                                this.showAddUserStory(true, null, this.state);
                                                }}
                                            >
                                                User Story
                                            </BoostrapDropdown.Item>
                                            )}

                                            
                                           {this.hasPermission("AT") && (
                                            <BoostrapDropdown.Item
                                                onClick={() => {
                                                const { masterProjectId, masterReleaseId } = this.state;

                                                // Clean URL (remove t param)
                                                let newUrl = "/dashboard";

                                                if (masterProjectId) {
                                                    newUrl += `?p=${masterProjectId}`;
                                                }

                                                if (masterReleaseId) {
                                                    newUrl += `${masterProjectId ? "&" : "?"}r=${masterReleaseId}`;
                                                }

                                                this.props.history.push(newUrl);

                                                // Clear taskId before opening modal
                                                this.setState({ taskId: null }, () => {
                                                    this.showAddTask(true, null, {
                                                    ...this.state,
                                                    taskId: null
                                                    });
                                                });
                                                }}
                                            >
                                                Task
                                            </BoostrapDropdown.Item>
                                            )}

                                            
                                        </BoostrapDropdown.Menu>
                                        </BoostrapDropdown>
                                    </li>
                                    ) : (
                                    " "
                                    )}

                                {/*{JSON.parse(localStorage.getItem("isGlobalAdmin")) ?
                                    <li>
                                        <div className="">
                                        <a className="rt-list add-form-btn" onClick={this.ReportMethod}>
                                                <i className="fa fa-flag" aria-hidden="true"></i> Report
                                            </a>
                                        </div>
                                    </li> : ""}
                                    {(JSON.parse(localStorage.getItem("isGlobalAdmin")) && isDashboard) ?
                                    <li>
                                        <div className="">
                                        <a className="rt-list add-form-btn" onClick={this.AssignProjectManagerMethod}>
                                                <i className="fa fa-users" aria-hidden="true"></i> Assign Project Manager
                                            </a>
                                        </div>
                                    </li> : ""}

                                     {(JSON.parse(localStorage.getItem("isGlobalAdmin")) && isProjectManager) ?
                                    <li>
                                        <div className="">
                                        <a className="rt-list add-form-btn" onClick={this.NavigateToDashbaord}>
                                                <i className="fa fa-users" aria-hidden="true"></i> ScrumBoard
                                            </a>
                                        </div>
                                    </li> : ""}*/}

                                <li className="hide-m-v">
                                    <Logout />
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>

            </header >
            {this.state.addProject ? <Project loadMasterProjectDdl={this.loadMasterProjectDdl} onHideProjectEvent={this.hideProjectHandler}></Project> : ""}
            {this.state.addRelease ? <Release loadMasterReleaseDdl={this.loadMasterReleaseDdl} onHideReleaseEvent={this.hideReleaseHandler}></Release> : ""}
            {this.state.openProjectList ? <EditProject loadMasterProjectDdl={this.loadMasterProjectDdl} val={this.state.openProjectList} projects={this.state.masterProjects} onHideEditProjectEvent={this.hideEditProjectHandler}></EditProject> : ""}
            {this.state.openReleaseList ? <EditRelease loadMasterReleaseDdl={this.loadMasterReleaseDdl} val={this.state.openReleaseList} projects={this.state.masterProjects} onHideEditReleaseEvent={this.hideReleaseListHandler} ></EditRelease> : ""}
            {this.state.openFeatureList ? <EditFeature loadMasterFeatureDdl={this.loadMasterFeatureDdl} val={this.state.openFeatureList} projects={this.state.masterProjects} onHideEditFeatureEvent={this.hideFeatureHandler} editFeature={this.props.editFeature} ></EditFeature> : ""}
            {this.state.openStoryList ? <EditStory loadMasterFeatureDdl={this.loadMasterFeatureDdl} val={this.state.openStoryList} projects={this.state.masterProjects} onHideEditStoryEvent={this.hideStoryHandler} editUserStory={this.props.editUserStory}></EditStory> : ""}
        <Modal
  show={this.state.showPermissionModal}
  onHide={this.closePermissionModal}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Project Permissions</Modal.Title>


  </Modal.Header>

  <Modal.Body>
  {this.getCurrentProjectRole()?.roleName && (
    <div
      style={{
        padding: "10px",
        marginBottom: "15px",
        background: "#f8f9fa",
        borderRadius: "5px",
        border: "1px solid #e0e0e0"
      }}
    >
      <strong>Your Role:</strong>{" "}
      {this.getCurrentProjectRole().roleName}
    </div>
  )}

  {this.renderProjectPermissions()}
</Modal.Body>


  <Modal.Footer>
    <Button variant="secondary" onClick={this.closePermissionModal}>
      Close
    </Button>
  </Modal.Footer>
</Modal>
    
        </div >
        );
    }
}

export default Header;